import _Header from '../_app/cuchillo/layout/Header';
import { Power3 } from "gsap";
import { Basics, isTouch } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { CSS } from '../_app/cuchillo/utils/CSS';

export default class Header extends _Header {
  static options = {
    show: {
      duration: .3,
      delay: 0,
      ease: Power3.easeOut
    },
    hide: {
      duration: .3,
      delay: 0,
      ease: Power3.easeIn
    }
  }

  static init() {
    super.init();
    
    this.logo = GetBy.class("logo", this.container)[0];
    this.isWhite = false;
  }

  static resize() {
    super.resize();

    this.max = this.logo?.offsetHeight;
    this.min = this.container.offsetHeight;
    this.offset = this.max;
  }

  static loop() {
    super.loop();

    if(!this.logo) return;

    this.offset = Math.max(this.min, this.max - Scroll.y);
    this.scale = this.offset == 0? 1 : this.offset/this.max;
    this.logo.style[CSS.transform] = CSS.scale3D(this.scale,this.scale,this.scale);

    if(Scroll.y > this.max && !this.isWhite) {
        this.isWhite = true;
        this.container.classList.add("--white");
    } else if(Scroll.y <= this.max && this.isWhite) {
        this.isWhite = false;
        this.container.classList.remove("--white");
    }
  }
}


